module.exports = __webpack_public_path__ + "static/img/8641_phase_function_Paper_Points.bfdc87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8641_phase_function_Paper_Points.png
// module id = n4WX
// module chunks = 0